import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button, message } from 'antd';
import { useSelector } from "react-redux";
import Dropdown from "../../components/search/Dropdown";
import { fetchDataForDropdown } from "../../services/Service";
import './SkillRepo.css';
import axios from 'axios';
import moment from 'moment';

const skills = ["JavaScript", "React", "Node.js", "Python", "Java"];
const experienceLevels = ["1-3 years", "3-6 years", "6+ years"];
const certifications = ["AWS", "Azure", "Google Cloud", "PMP"];
const visaCountries = ["United Kingdom", "United States of America"];
const mentors = ["John Doe", "Jane Smith", "Emily Brown"];
const accounts = ["Account A", "Account B", "Account C"];

const SkillRepo = ({ modalVisible, setModalVisible, onClose, userId, onSkillRepoCreate }) => {
  const [isEditMode, setIsEditMode] = useState(false); // Track if form is in edit mode
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const token = useSelector((state) => state.auth.token);
  const [userData, setUserData] = useState({});
  const normalUserId = localStorage.getItem("userrId");
  const userRole = localStorage.getItem("userRoles");
  const userName=localStorage.getItem("userrname");
  console.log("userName ", userName);
  console.log("userUid", normalUserId);

  useEffect(() => {
    if (userId || normalUserId) {
      console.log("Fetching user data...");
      fetchUserData();
    } else {
      console.log("No userId or normalUserId available.");
    }
  }, [userId]);

  const fetchUserData = async () => {
    try {
      let idToFetch = userId || normalUserId;
      console.log("Using ID for API call:", idToFetch);

      if (!idToFetch) {
        console.log("No user ID available to fetch data.");
        return;
      }

      const res = await axios.get(`http://localhost:8080/skillset/${idToFetch}`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Add this if token is required
        },
      });

      
      // Parse the joiningDate to moment object if available
      if (res.data.joiningDate) {
        // Convert the ISO date string into a moment object
        res.data.joiningDate = moment(res.data.joiningDate);
        
      }

      if (res.data.visaValid) {
        // Convert the ISO date string into a moment object
        res.data.visaValid = moment(res.data.visaValid);
      }

      // Set user data including formatted joiningDate
      setUserData(res.data);
      form.setFieldsValue(res.data);  // Populate the form with fetched data
      form.setFieldsValue({
        uid: normalUserId,
        name: userName,
      });

      // console.log("Fetched user data:", res.data);
      // setUserData(res.data);
      // form.setFieldsValue(res.data); // Populate form fields
      // console.log("userRole:", userRole);

      // If user data exists, make the form disabled for normal users
      if (userRole.includes("NORMALUSER")) {
        setIsEditMode(false); // Disable the form and show edit button
      }

    } catch (error) {
      setUserData(null);
      console.error("Error fetching user data:", error);
     // message.error("Error fetching user data.");
    }
  };
  // const [fileList, setFileList] = useState([]);
  // const [loading, setLoading] = useState(false);

  // const handleFileChange = (info) => {
  //   let newFileList = [...info.fileList];
  //   setFileList(newFileList);
  // };

  // If user role is not 'normaluser', disable the form and remove buttons
  const isFormDisabled = !userRole.includes("NORMALUSER") || !isEditMode;

  const handleSkillRepoCreate = async () => {
    setLoading(true);
    try {
        const response = await onSkillRepoCreate();
        
        if (response.ok) {
            onClose(); // Close the modal only if the API call is successful
        } else {
            throw new Error("Failed to save Skillset Repository.");
        }
    } catch (error) {
        console.error("Error creating Skillset Repository:", error);
    } finally {
        setTimeout(() => setLoading(false), 2000);
    }
};
  return (
    <Modal
      title="Skill Repository Form"
      visible={modalVisible}
      onCancel={onClose}
      footer={null}
      //onOk={handleSkillRepoCreate}
      width={800}
      
      className="p-0" // Keep Modal clean, scroll inside inner div
>
  <div className="max-h-[70vh] overflow-y-auto p-6">
    {/* Your modal content goes here */}
 

    
       
      <Form
        form={form}
        initialValues={{uid:normalUserId,name:userName}}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        disabled={isFormDisabled} // Disable form based on conditions
      >
        <Form.Item label="ID" name="uid"><Input disabled /></Form.Item>
        <Form.Item label="Name" name="name"><Input disabled  /></Form.Item>

        <Form.Item name="birthDay" label="Actual Birth Day" rules={[{ required: true }]}> 
        <Select className="w-full" placeholder="Select Birth Month"
            >
              {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                <Select.Option key={day} value={day}>{day}</Select.Option>
              ))}
            </Select>
</Form.Item>
        
        <Form.Item name="birthMonth" label="Actual Birth Month" rules={[{ required: true }]}> 
  <Select className="w-full" placeholder="Select Birth Month">
    {/* Render the months as dropdown options */}
    {[
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ].map((month, index) => (
      <Select.Option key={index} value={month}>{month}</Select.Option>
    ))}
  </Select>
</Form.Item>

<Form.Item name="joiningDate" label="Walmart Joining Date" rules={[{ required: true }]}> 
      <DatePicker className="w-full" />
    </Form.Item>

        
        <Form.Item label="Walmart Login ID" name="loginId" rules={[{ required: true, message: 'Walmart Login ID required' }]}> 
          <Input placeholder="Enter Walmart Login ID" />
        </Form.Item>

        <Form.Item label="Walmart System Name" name="walmartSystemName" rules={[{ required: true, message: 'Walmart System ID required' }]}> 
          <Input placeholder="Enter Walmart System ID" />
        </Form.Item>

        <Form.Item label="Overall Experience" name="overallExp" rules={[{ required: true, message: 'Select experience level' }]}> 
          <Select placeholder="Experience Level">{experienceLevels.map(l => (<Select.Option key={l} value={l}>{l}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Main Skillset" name="mainSkillSet"> 
          <Select placeholder="Select Skill">{skills.map(s => (<Select.Option key={s} value={s}>{s}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Experience in Main Skillset" name="expInMainSkillset" rules={[{ required: true, message: 'Select experience level' }]}> 
          <Select placeholder="Experience in Main Skillset Level">{experienceLevels.map(l => (<Select.Option key={l} value={l}>{l}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Additional Skillset expertise(>2 year)" name="additionalSkillsetExp"> 
        <Select mode="multiple" placeholder="Select Certifications">{certifications.map(c => (<Select.Option key={c} value={c}>{c}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Additional Skillset beginner(<2 year)" name="additionalSkillsetBeginner"> 
        <Select mode="multiple" placeholder="Select Certifications">{certifications.map(c => (<Select.Option key={c} value={c}>{c}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Other Skillset" name="otherSkillset"> 
        <Input.TextArea placeholder="Enter Skils" />
        </Form.Item>

        <Form.Item label="External Certifications" name="externalCertifications" rules={[{ required: true, message: "Select at least one certification!" }]}>
          <Select mode="multiple" placeholder="Select Certifications">{certifications.map(c => (<Select.Option key={c} value={c}>{c}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Other Certifications/Tools/Domain Knowledge" name="otherCertificates" rules={[{ required: true, message: "Select at least one certification!" }]}>
        <Input.TextArea placeholder="Enter Skils" />
        </Form.Item>


        <Form.Item label="Comments" name="comments"><Input.TextArea placeholder="Enter details" /></Form.Item>
        <Form.Item label="Hobbies" name="passion"><Input.TextArea placeholder="Your hobbies" /></Form.Item>

        {/* <Form.Item label="Resume" rules={[{ required: true }]}>
        <Upload
          action=""
          listType="picture"
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false} // Prevent auto-upload, we handle that manually
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item> */}

        <Form.Item label="Visa Country" name="visaCountry">
          <Select placeholder="Select Visa Country">{visaCountries.map(v => (<Select.Option key={v} value={v}>{v}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Visa Type" name="type">
          <Select placeholder="Select Visa Country">{visaCountries.map(v => (<Select.Option key={v} value={v}>{v}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item name="visaValid" label="Visa Valid Date" rules={[{ required: true }]}> 
      <DatePicker className="w-full" />
    </Form.Item>

        <Form.Item label="Mentor" name="mentor">
          <Select placeholder="Select Mentor">{mentors.map(m => (<Select.Option key={m} value={m}>{m}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Account" name="account">
          <Select placeholder="Select Account">{accounts.map(a => (<Select.Option key={a} value={a}>{a}</Select.Option>))}</Select>
        </Form.Item>

        <Form.Item label="Location" name="location">
          <Dropdown fetchData={() => fetchDataForDropdown("locations")} placeholder="Select Location" includeAll={true} />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "right" }}>
        {userRole.includes("NORMALUSER") && userData && isEditMode && (
    <Button
      type="primary"
      htmlType="submit"
      loading={loading}
      onClick={async () => {
        try {
          // Submit the form and trigger API call after form submission
          await form.submit(); // Submit the form
  
          // Call your API after the form submission
          const formData = form.getFieldsValue(); // Get form values
  
          const token = localStorage.getItem("token"); 
          console.log(formData);
          formData.uid=normalUserId;
          formData.name=userName;
          // fileList.forEach(file => {
          //   formData.append('file', file.originFileObj);
          // });

           // Format the birthDate or any other date fields before sending
    const birthDate = formData.actualBirthMonth ? formData.actualBirthMonth.format("YYYY-MM-DD") : null;
    
    // Update the formData with the correct formatted date
    formData.actualBirthMonth = birthDate;

     // Format the joiningDate (ensure it's in the correct format before sending)
     const formattedJoiningDate = formData.joiningDate ? formData.joiningDate.format("YYYY-MM-DD") : null;

     // Update the formData with the correctly formatted date
     formData.joiningDate = formattedJoiningDate;
    
            const response = await axios.put(`http://localhost:8080/skillset`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`, // Attach the token in the Authorization header
                    "Content-Type": "application/json"
                }
            });
          
      //    message.success('Form submitted and API called successfully!');
          console.log('API Response:', response.data);
          handleSkillRepoCreate();
          setModalVisible(false);
          
  
        } catch (error) {
        //  message.error('Failed to submit form and call API');
          console.error('Error:', error);
        }
      
    }}
    >
      Update
    </Button>
  )}

  {/* You can still keep this for handling the form submission if required */}
  {userRole.includes("NORMALUSER") && !userData && isEditMode && (
    <Button
      type="primary"
      htmlType="submit"
      loading={loading}
      onClick={async () => {
        try {
          // Submit the form and trigger API call after form submission
          await form.submit(); // Submit the form
  
          // Call your API after the form submission
          const formData = form.getFieldsValue(); // Get form values
          formData.uid=normalUserId;
          formData.name=userName;
  
          const token = localStorage.getItem("token"); 

    
            const response = await axios.post(`http://localhost:8080/skillset`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`, // Attach the token in the Authorization header
                    "Content-Type": "application/json"
                }
            });
           
         // message.success('Form submitted and API called successfully!');
          console.log('API Response:', response.data);
          setModalVisible(false);
          handleSkillRepoCreate();
        } catch (error) {
          //message.error('Failed to submit form and call API');
          console.error('Error:', error);
        }
      
    }}
    >
      Save
    </Button>
  )}
</Form.Item>

      </Form>
      {userRole.includes("NORMALUSER")  && !isEditMode && (
    <Button
      type="primary"
      onClick={() => setIsEditMode(true)}
    >
      Edit
    </Button>
  )}
   </div>
    </Modal>
  );
};

export default SkillRepo;
